"use strict";

// module.exports = [
//   { level: "1", code: "EMER", label: "Emergency Room" },
//   { level: "2", code: "ACUTE", label: "Inpatient Admission" },
//   { level: "3", code: "NONAC", label: "Post Acute Admission" },
//   { level: "4", code: "SS", label: "Observation Stay" }
// ];

module.exports = [
  { level: "1", code: "inpatient_hospital", label: "Inpatient Hospital" },
  { level: "1", code: "inpatient_w_icu", label: "Inpatient w/ICU" },
  { level: "1", code: "provider_appointment", label: "Provider Appointment" },
  { level: "1", code: "ed", label: "ED" },
  { level: "1", code: "post_acute", label: "Post Acute" },
  { level: "1", code: "snf", label: "SNF" },
  { level: "1", code: "hospice", label: "Hospice" }
];
